import React from 'react';

function UserProfileList() {
    return (
        <div className="messaging__user-box">
            <h1>Noman Gazi</h1>
        </div>
    );
}

export default UserProfileList;
